import { Content } from 'data/types'
import React from 'react'

import {
  InstructionsContentSection,
  InstructionsCopy,
  InstructionsFooter,
  InstructionsFooterBody,
  InstructionsFooterTitle,
  InstructionsSectionItemBody,
  InstructionsSectionItemTitle,
  InstructionsSectionList,
  InstructionsSectionListItem,
  InstructionsSectionTitle
} from './styles'

type Props = {
  content: Content
}

const Instructions = ({ content }: Props) => (
  <>
    {content.sections.map((section) => (
      <InstructionsContentSection key={section.name}>
        <InstructionsSectionTitle>{section.name}</InstructionsSectionTitle>
        <InstructionsSectionList>
          {section.entries.map((entry) => (
            <InstructionsSectionListItem key={entry.id}>
              <InstructionsSectionItemTitle>{entry.title}</InstructionsSectionItemTitle>
              <InstructionsSectionItemBody>{entry.message}</InstructionsSectionItemBody>
              <InstructionsCopy light value={entry.message} />
            </InstructionsSectionListItem>
          ))}
        </InstructionsSectionList>
      </InstructionsContentSection>
    ))}
    {content.footers.map((footer) => (
      <InstructionsFooter key={footer.title}>
        <InstructionsFooterTitle>{footer.title}</InstructionsFooterTitle>
        <InstructionsFooterBody>{footer.message}</InstructionsFooterBody>
      </InstructionsFooter>
    ))}
  </>
)

export default Instructions
